import { render } from "./testimonialView.vue?vue&type=template&id=7d17f704"
import script from "./testimonialView.vue?vue&type=script&lang=js"
export * from "./testimonialView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__